import config from '../config';

export const isShittyKittiesAsset = (asset) => {
  const shittyKittiesCreators = [
    process.env.NEXT_PUBLIC_FIRST_LITTER_CREATOR,
    process.env.NEXT_PUBLIC_SECOND_LITTER_CREATOR,
    process.env.NEXT_PUBLIC_THIRD_LITTER_CREATOR,
    process.env.NEXT_PUBLIC_FOURTH_LITTER_CREATOR,
  ].filter(Boolean);

  return shittyKittiesCreators.includes(asset['creator-address'] || asset.creator);
};

export const getShittyVaultAddress = () => {
  return config.donationConfig.destination.address;
};

export const formatDonationNote = (donation) => {
  const noteObj = {
    donation: true,
    address: donation.address,
    assets: donation.assets,
    destination: config.donationConfig.destination.name,
    authorization: process.env.NEXT_PUBLIC_API_KEY,
    timestamp: Date.now(),
  };
  return Buffer.from(JSON.stringify(noteObj)).toString('base64');
};

export const validateDonationAssets = (assets) => {
  const errors = [];

  if (!assets || assets.length === 0) {
    errors.push('No assets selected for donation');
    return errors;
  }

  const maxAssets = parseInt(process.env.NEXT_PUBLIC_MAX_DONATION_ASSETS) || 20;
  if (assets.length > maxAssets) {
    errors.push(`Maximum ${maxAssets} assets can be donated at once`);
  }

  const shittyKittiesAssets = assets.filter(isShittyKittiesAsset);
  if (shittyKittiesAssets.length > 0) {
    errors.push('Shitty Kitties NFTs cannot be donated to prevent accidents');
  }

  return errors;
};
